/* eslint react-hooks/exhaustive-deps: 0 */
import { useEffect, useState } from 'react';
import axios                     from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { BASE_URL } from '../../constants/paths';
import Footer from './Footer';
import TopNavbar from '../Nav/TopNavbar';
import { Button, CircularProgress, Container } from '@material-ui/core';
import { Paper } from '@mui/material';
import { Title } from '@mui/icons-material';








//const API = import.meta.env.VITE_API_URL; // e.g. https://chamaflow-api.roshtech.co.ke

export default function RenewSubscription() {
  const { invoiceId } = useParams();          // url /renew/:invoiceId
  const [invoice, setInvoice] = useState(null);
  const [loading, setLoading] = useState(true);
  const nav = useNavigate();

  /* --- fetch invoice once --- */
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await axios.get(`${BASE_URL}invoice/${invoiceId}`);
        if (!cancelled) setInvoice(data);
      } catch (err) {
        console.error(err);
        nav('/not-found');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  if (loading) {
    return (
      <>
      <TopNavbar/>
        <Container p="xl" style={{ textAlign: 'center' }}>
          <CircularProgress/>
        </Container>
        <Footer/>
      </>
    );
  }

  if (!invoice) return null; // nav already redirected on error

  const payNow = () => window.location.href = invoice.authorization_url;
  const downloadPdf = () => window.open(`${BASE_URL}invoice/${invoice.id}/pdf`, '_blank');

  return (
    <>
      <TopNavbar />
      <Container size="md" py="xl">
        <div shadow="md" radius="md" p="xl" withBorder>
          <Title order={3} mb="md">Invoice #{invoice.id.slice(0, 8)}</Title>

          <p><strong>Product:</strong> ChamaFlow&nbsp;– {invoice.edition}</p>
          <p><strong>Amount&nbsp;Due:</strong> KES {invoice.amount_kes}</p>
          <p><strong>Due&nbsp;Date:</strong> {new Date(invoice.due_date).toDateString()}</p>

          <Container mt="xl">
            <Button color="indigo" onClick={payNow}>
              Pay now with Paystack
            </Button>
            <Button variant="outline" onClick={downloadPdf}>
              Download PDF
            </Button>
          </Container>
        </div>
      </Container>
      <Footer />
    </>
  );
}
